import { useContext } from 'react';
import { PoliceChartsDataContext } from '../contexts/PoliceChartsDataContext';

export const usePoliceChartsDataContext = () => {
    return useContext(PoliceChartsDataContext);
};
